import { render } from "./sortingArrow.vue?vue&type=template&id=65820b4b&ts=true"
import script from "./sortingArrow.vue?vue&type=script&lang=ts"
export * from "./sortingArrow.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__